import React from "react";
import { Row, Col, Card, Divider } from "antd";
import { InfoCircleFilled } from "@ant-design/icons";



const ErrorCard = ({ message, extraMessage }) => {


    return (
        <Row gutter={24}>
            <Col span={24}>
                <Row gutter={24}>
                    <Col span={24}>
                        <Divider className="w-100" style={{ marginTop: "0px", marginBottom: "0px" }} />
                    </Col>
                </Row>
                <Row gutter={24}>
                    <Col span={24}>
                        <Card className="mt-4 mb-4" style={{ borderRadius: "0", border: "none" }}>
                            <Row gutter={24} className="h-100" align="middle">
                                <Col span={24} className="text-center">
                                    <InfoCircleFilled style={{ fontSize: "45px", color: "#faad14" }} />
                                </Col>
                                <Col span={24} className="text-center h-100 mt-4">
                                    <h3 className="m-0 p-0" style={{ fontWeight: "400" }}>{message}</h3>
                                </Col>
                                <Col span={24} className="text-center h-100">
                                    <h4 className="m-0 p-0" style={{ fontWeight: "400" }}>{extraMessage}</h4>
                                </Col>
                            </Row>
                        </Card>
                    </Col>
                </Row>
                <Row gutter={24}>
                    <Col span={24}>
                        <Divider className="w-100" style={{ marginTop: "0px", marginBottom: "0px" }} />
                    </Col>
                </Row>
            </Col>
        </Row>
    );
};

export default ErrorCard;